import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

// 排行榜 API
export const rankingsApi = {
  getAll: () => api.get('/rankings'),
  getById: (id: string) => api.get(`/rankings/${id}`),
  create: (data: any) => api.post('/rankings', data),
  update: (id: string, data: any) => api.put(`/rankings/${id}`, data),
  delete: (id: string) => api.delete(`/rankings/${id}`),
};

// 排行榜项目 API
export const rankingItemsApi = {
  getByRankingId: (rankingId: string) => api.get(`/rankings/${rankingId}/items`),
  create: (data: any) => api.post('/ranking-items', data),
  update: (id: string, data: any) => api.put(`/ranking-items/${id}`, data),
  delete: (id: string) => api.delete(`/ranking-items/${id}`),
  updateOrder: (rankingId: string, items: any[]) => 
    api.put(`/rankings/${rankingId}/items/order`, { items }),
};

// 记录排行榜点击
export const recordRankingClick = async (rankingId: string) => {
  try {
    await api.post(`/rankings/${rankingId}/click`);
  } catch (error) {
    console.error('记录点击失败:', error);
  }
};

// 首页 API - 由于后端没有专门的首页 API，我们使用排行榜 API 来获取数据
export const homeApi = {
  getAllHomeData: async () => {
    const response = await rankingsApi.getAll();
    const allRankings = response.data;
    
    // 将所有榜单分为三类：推荐、最新和热门
    // 这里简单地按照索引分类，实际项目中可能需要根据其他属性分类
    const featuredRankings = allRankings.slice(0, Math.min(3, allRankings.length));
    const latestRankings = allRankings.slice(0, Math.min(100, allRankings.length));
    const popularRankings = allRankings.slice(0, Math.min(4, allRankings.length));
    
    return {
      data: {
        featuredRankings,
        latestRankings,
        popularRankings
      }
    };
  }
};

export default api; 